/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=fb7ee43a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=fb7ee43a&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=fb7ee43a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7ee43a"]])

export default __exports__